import Route from 'mewe/routes/route';

import { fetchEventsCounters, getCounters } from 'mewe/fetchers/fetch-events-counters';

export default Route.extend({
  theme: 'group',

  model(params, transition) {
    let { to: toRouteInfo } = transition;

    this.groupId = toRouteInfo.parent.parent.params.group_id;

    if (this.fetchCountersInModel) {
      fetchEventsCounters(this.groupId);
      this.fetchCountersInModel = false;
    }

    return {
      group: this.modelFor('app.group').group,
      groupId: this.groupId,
      counters: getCounters(this.groupId),
    };
  },

  activate: function () {
    this._super();
    if (!this.groupId) {
      this.fetchCountersInModel = true;
    } else {
      fetchEventsCounters(this.groupId);
    }
  },
});
